module.exports = __webpack_public_path__ + "static/media/review.f10dac3f.svg";